import PropTypes from 'prop-types'
import React from 'react'
import { ReactSVG } from 'react-svg'
import informationBlockIcon from '../../../images/icons/information_block.svg'
import BoldLabelAndContent from '../../molecules/BoldLabelAndContent'
import InformationBlockField from '../question_config_fields/InformationBlockField'
import InformationBlockCitizenField from '../question_fields/InformationBlockCitizenField'

const Form = props => {
  return <InformationBlockField baseName={props.baseName} />
}

const Answer = props => (
  <BoldLabelAndContent label={props.question.payload?.label} content={props.answer} className="mb-3" />
)

const Template = props => (
  <InformationBlockCitizenField payload={props.question.payload} className="pb-4" position={props.question.position} />
)

const InformationBlockQuestion = {
  selectOption: {
    value: 'information_block',
    label: 'Bloque informativo',
    icon: <ReactSVG src={informationBlockIcon} />
  },
  Form,
  Template,
  Answer,
  TaskResponse: Answer,
  Response: Answer,
  name: 'InformationBlockQuestion',
  subtype: 'Bloque informativo'
}

export default InformationBlockQuestion

Form.propTypes = {
  baseName: PropTypes.string
}

Answer.propTypes = {
  answer: PropTypes.object,
  question: PropTypes.object.isRequired
}

Template.propTypes = {
  question: PropTypes.object.isRequired
}
